import { render, staticRenderFns } from "./campaign-uncompleted.vue?vue&type=template&id=0df87b4a&scoped=true"
import script from "./campaign-uncompleted.vue?vue&type=script&lang=js"
export * from "./campaign-uncompleted.vue?vue&type=script&lang=js"
import style0 from "./campaign-uncompleted.vue?vue&type=style&index=0&id=0df87b4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df87b4a",
  null
  
)

export default component.exports